<template>
  <v-dialog 
    v-model="navigation.dialogIsVisible" 
    @update:model-value="navigation.dialogIsVisible == false ? closeCRMShutdownDialog() : null" 
    max-width="30vw"
    style="user-select: none; cursor: default;"
  >        
    <v-card style="max-height: 90vh; display: flex; flex-direction: column;">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" size="large">mdi-cog</v-icon>
            <v-icon color="indigo">mdi-toggle-switch</v-icon>
            <h3>SHUTDOWN</h3>
          </div>
          <div class="actionsContainer">
            <v-btn 
              @click="closeCRMShutdownDialog()"
              :disabled="loader.action"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      </div>
      <div style="padding: 15px;">
        <template v-if="loader.startup == true">
          <div style="text-align: center;">
            <v-progress-circular color="indigo" indeterminate></v-progress-circular>
          </div>
        </template>
        <template v-else>
          <p>
            La aplicación se encuentra
            <template v-if="display.CRMStatus == 'active'">
              <span style="font-weight: bold; color: green">ACTIVA</span>.
              Al desactivar la aplicación, todos los usuarios que no tengan habilitada la credencial de acceso <strong>/shutdown</strong> perderán el acceso al sistema. ¿Desea continuar?
            </template>
            <template v-else>
              <span style="font-weight: bold; color: red">INACTIVA</span>.
              Al activar la aplicación, todos los usuarios recuperarán el acceso al sistema. ¿Desea continuar?
            </template>
          </p>
        </template>
      </div>
      <template v-if="loader.startup == false">
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
        <v-card color="primary" elevation="0" rounded="0" style="padding: 15px;">
          <v-btn 
            @click="updateCRMStatus()"
            :disabled="loader.action"
            :color="display.CRMStatus == 'active' ? 'error' : 'success'" 
            block
            class="hoverableText" 
          >
            <v-icon style="margin-right: 10px;">mdi-toggle-switch</v-icon>
            <h3>{{ display.CRMStatus == 'active' ? 'DESACTIVAR APLICACIÓN' : 'ACTIVAR APLICACIÓN' }}</h3>
          </v-btn>
        </v-card>
      </template>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.headerCard {
  padding: 15px;
  display: grid;
  justify-content: center;
  align-items: center;
  gap: 10px;
  grid-template-columns: repeat(2, 1fr);
}

.titleContainer {
  display: flex;
  align-items: center;
  gap: 10px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

@media (max-width: 1200px) {
  .headerCard {
    grid-template-columns: 1fr;
  }
  .titleContainer {
    justify-content: center;
  }
  .actionsContainer {
    justify-content: center;
    margin-left: 0;
  }
}
</style>

<script>
  export default {
    inject: ['$generalFunctions'],

    data: () => 
    ({
      display: 
      {
        CRMStatus: 'active'
      },
      navigation: 
      {
        dialogIsVisible: false
      },
      loader: 
      {
        startup: false,
        action: false
      }
    }),
    methods:
    {
      async updateCRMStatus(){
        this.loader.action = true;
        const updateCRMStatusRequestQuery =
        {
          'CRMStatus': this.display.CRMStatus
        };
        const updateCRMStatusRequest = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAccount/functions/updateCRMStatus', updateCRMStatusRequestQuery);
        if (updateCRMStatusRequest.success == true){
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMStatus_success', 'success', `Aplicación ${this.display.CRMStatus == 'active' ? 'desactivada' : 'activada'} exitosamente`, null, true);
          this.closeCRMShutdownDialog();
        }
        else this.$root.notificationDialog.showSystemNotificationDialog('updateCRMStatus_error', 'error', 'Ha ocurrido un error inesperado al actualizar el estado de la aplicación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        this.loader.action = false;
      },

      async openCRMShutdownDialog(){
        this.navigation.dialogIsVisible = true;
        this.loader.startup = true;
        const getCRMStatusRequest = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAccount/functions/getCRMStatus', {});
        if (getCRMStatusRequest.success == true){
          this.loader.startup = false;
          this.display.CRMStatus = getCRMStatusRequest.result;
        } else {
          this.closeCRMShutdownDialog();
          this.$root.notificationDialog.showSystemNotificationDialog('openCRMShutdownDialog_error', 'error', 'Ha ocurrido un error inesperado al consultar el estado de la aplicación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
      closeCRMShutdownDialog(){
        this.navigation.dialogIsVisible = false;
        this.$emit('closeCRMShutdownDialog');
      }
    }
  }
</script>